/* eslint-disable react/prop-types */
import { Accordion, Button, Col, Container, Form, Row } from "react-bootstrap";
import { Calendar } from "react-bootstrap-icons";
import Select from "react-select";

const DateFilter = ({ title, value, onChange }) => {
    return (
        <Col lg={2} md={4}  xs={6}>
            <Form.Group className="my-1">
                <Form.Label className="d-flex align-items-center gap-2"><Calendar size={16}/> {title}</Form.Label>
                <Form.Control
                    type='date'
                    value={value}
                    onChange={onChange}
                />
            </Form.Group>
        </Col>
    );
};

const RangeFilter = ({
    title,
    lowerFilter,
    setLowerFilter,
    upperFilter,
    setUpperFilter,
    lowerPlaceHolder,
    upperPlaceHolder
}) => {
    return (
    // TODO: Text
        <Col lg={2} md={4}  xs={6}>
            <Form.Group className="my-1">
                <Form.Label>{title}</Form.Label>
                <Form.Control
                    placeholder={lowerPlaceHolder}
                    type="number"
                    value={lowerFilter}
                    onChange={setLowerFilter}
                />
                <Form.Control
                    placeholder={upperPlaceHolder}
                    type="number"
                    className="mt-1"
                    value={upperFilter}
                    onChange={setUpperFilter}
                />
            </Form.Group>
        </Col>
    );
};
  
const DateRangeFilter = ({
    title,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    lowerPlaceHolder,
    upperPlaceHolder
}) => {
    return (
        // TODO: Text
        <Col lg={2} md={4}  xs={6}>
            <Form.Group className="my-1">
                <Form.Label>{title}</Form.Label>
                <Form.Group className="mb-1 d-flex justify-content-center align-items-center ">
                <Form.Control
                    className="ms-2"
                    type='date'
                    value={dateFrom}
                    onChange={e => setDateFrom(e)}
                />
                </Form.Group>
            </Form.Group>
        </Col>
    );
};
  
const SelectFilter = ({ title, value, onChange, options, isMulti }) => {
    return (
        <Col lg={2} md={4}  xs={6}>
            <Form.Group className="my-1">
                <Form.Label>{title}</Form.Label>
                <Select
                    value={value}
                    isMulti={isMulti}
                    onChange={onChange}
                    options={options}
                />
            </Form.Group>
        </Col>
    );
};

const ActionButton = ({title, onClick}) =>{
    return(
        <Col lg={2} md={4}  xs={6}>
            <Form.Group >
                <Form.Label>{"title"}</Form.Label>
                <Button
                    title={title}
                    variant="success"
                    onClick={onClick}
                >
                    {title}
                </Button>
            </Form.Group>
        </Col>
    )
}


const TopToolBar = ({ filters }) => {
    return (
        <Container fluid className="p-0 m-0 bg-main">
            <Accordion bsPrefix="">
                <Accordion.Item>
                    <Accordion.Header bsPrefix="">
                        <Row style={{ flex: 1 }}>
                            <Col sm={10}>Filters</Col>
                        </Row>
                    </Accordion.Header>
                    <Accordion.Body bsPrefix="p-3 bg-main">
                    {
                        filters.rows?.map((row, idx) =>{
                            return(
                                <Row className="p-0 mb-0" key={idx}>
                                    {
                                        row?.map(filter => {
                                            switch (filter.type) {
                                                case 'date':
                                                    return (
                                                        <DateFilter
                                                            title={filter.title}
                                                            value={filter.value ?? ""}
                                                            onChange={filter.onChange}
                                                        />
                                                    );
                                                
                                                case 'button':
                                                    return(
                                                        <ActionButton
                                                            title={filter.title}
                                                            onClick={filter.onClick}
                                                        />
                                                    )
                                                
                                                case 'range':
                                                    return (
                                                        <RangeFilter
                                                            key={filter.title}
                                                            title={filter.title}
                                                            lowerFilter={filter.lowerFilter}
                                                            setLowerFilter={filter.setLowerFilter}
                                                            upperFilter={filter.upperFilter}
                                                            setUpperFilter={filter.setUpperFilter}
                                                            lowerPlaceHolder={filter.lowerLimitPlaceHolder}
                                                            upperPlaceHolder={filter.upperLimitPlaceHolder}
                                                        />
                                                    );
                        
                                                    case 'select':
                                                        return (
                                                            <SelectFilter
                                                                key={filter.title}
                                                                title={filter.title}
                                                                value={filter.value}
                                                                onChange={filter.onChange}
                                                                options={filter.options}
                                                                isMulti={filter.isMulti}
                                                            />
                                                        );
                        
                                                    case 'dateRange':
                                                        return (
                                                            <DateRangeFilter
                                                                key={filter.title}
                                                                title={filter.title}
                                                                dateFrom={filter.dateFrom}
                                                                setDateFrom={filter.setDateFrom}
                                                                dateTo={filter.dateTo}
                                                                setDateTo={filter.setDateTo}
                                                                lowerPlaceHolder={filter.lowerLimitPlaceHolder}
                                                                upperPlaceHolder={filter.upperLimitPlaceHolder}
                                                            />
                                                        );
                        
                                                    default:
                                                        return null;
                                            }
                                        } )
                                    }
                                </Row>
                            )
                        })
                    }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </Container>
    )
}

export default TopToolBar;